export default "__VITE_ASSET__DlhsmD4U__"